module.exports = __webpack_public_path__ + "img/feedback4-3.2c5c0471.jpg";